import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Admin from './Pages/Admin'
import EditeProfilePage from './Pages/EditeProfile_page'
import EditeBlog from './Pages/Blogs/EditeBlog_page'
import BlogPage from './Pages/Blogs/BlogPage'
import AddNewBlog from './Pages/Blogs/AddNew_blog'
import ProductsPage from './Pages/Products/Products_page'
import EditeProducts from './Pages/Products/EditeProducts'
import SupportPage from './Pages/Support/Support_page'
import ServicePage from './Pages/Services/Service_page'
import EnquiryPage from './Pages/Support/Enquiry_page'
import StockChart from './Pages/StockCharts/StockChart'
import Sales from './Pages/sales/Sales'
import Login from './Authentication/Login'
import Signup from './Authentication/Signup'
import Dashboard from './EmployeesViews/Dashboard'
import ProtectedRoute from './Components/ProtectedRoute'
// import './App.css'

function App() {
  return (
    <Router>
      <Routes>
        {/* Authentication routes - Not protected */}
        <Route path="/login" element={<Login/>} />
        <Route path='/signup' element={<Signup/>} />
        <Route path="/" element={<Login />} />

        {/* Protected routes - Require authentication */}
        <Route path="/blogs" element={<ProtectedRoute><BlogPage /></ProtectedRoute>} />
        <Route path="/products" element={<ProtectedRoute><ProductsPage /></ProtectedRoute>} />
        <Route path="/edit-product/:id" element={<ProtectedRoute><EditeProducts /></ProtectedRoute>} />
        <Route path="/support-center" element={<ProtectedRoute><SupportPage /></ProtectedRoute>} />
        <Route path="/services" element={<ProtectedRoute><ServicePage /></ProtectedRoute>} />
        <Route path="/enquiry" element={<ProtectedRoute><EnquiryPage /></ProtectedRoute>} />
        <Route path="/stock-chart" element={<ProtectedRoute><StockChart /></ProtectedRoute>} />
        <Route path="/sales" element={<ProtectedRoute><Sales /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
        <Route path="/edit-profile" element={<ProtectedRoute><EditeProfilePage /></ProtectedRoute>} />
        <Route path="/edit-blog/:id" element={<ProtectedRoute><EditeBlog /></ProtectedRoute>} />
        <Route path="/add-blog" element={<ProtectedRoute><AddNewBlog /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      </Routes>
    </Router>
  )
}

export default App 